<template>
  <div class="main-content-container">
    <div class="top-content-container">
      <b-row>
        <b-col md="8">
          <b-breadcrumb class="customer-breadcrumbs pb-2">
            <b-breadcrumb-item>
              <span
                @click="$router.push({ name: 'TaskDashboard' })"
                class="text-uppercase font-family-medium"
              >
                Tasks
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                Handover
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <h1
            class="font-lg primary-dark font-family-medium position-relative content-title"
          >
            Handover
          </h1>
        </b-col>
      </b-row>
    </div>
    <b-tabs
      v-model="tabIndex"
      @input="getActiveTab"
      class="position-relative"
      active-nav-item-class="danger"
    >
      <b-tab title="To Me">
        <HandoverToMe v-if="profileUserId" />
      </b-tab>
      <b-tab title="To Others" v-if="role === 'assistant'">
        <HandoverToOthers v-if="profileUserId && tabIndex === 1" />
      </b-tab>
      <b-tab title="To Others" v-else>
        <HandoverToOthersAdmin v-if="profileUserId && tabIndex === 1" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
// import ToggleBtn from 'vue-toggle-btn/toggle-btn.vue';
import { mapState } from "vuex";
import HandoverToMe from "./handover/HandoverToMe";
import HandoverToOthers from "./handover/HandoverToOthers";
import HandoverToOthersAdmin from "./handover/HandoverToOthersAdmin";
export default {
  name: "HandoverTasks",
  data() {
    return {
      tabIndex: 0
    };
  },
  created() {
    this.tabIndex = Number(this.$route.params.tab);
  },
  computed: {
    ...mapState("authModule", ["role", "profileUserId"])
  },
  components: {
    HandoverToMe,
    HandoverToOthers,
    HandoverToOthersAdmin
  },
  watch: {
    $route(to) {
      if (to.params && Number.isInteger(to.params.tab)) {
        this.tabIndex = Number(to.params.tab);
        // this.getActiveTab()
      }
    }
  },
  methods: {
    getActiveTab() {
      this.$router.push({
        name: "HandoverTasks",
        params: {
          tab: this.tabIndex
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
